import { render } from "./MailAuth.vue?vue&type=template&id=1aaf564d&scoped=true"
import script from "./MailAuth.vue?vue&type=script&setup=true&lang=js"
export * from "./MailAuth.vue?vue&type=script&setup=true&lang=js"

import "./MailAuth.vue?vue&type=style&index=0&id=1aaf564d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aaf564d"],['__file',"src/views/mail/MailAuth.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1aaf564d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1aaf564d', __exports__)) {
    api.reload('1aaf564d', __exports__)
  }
  
  module.hot.accept("./MailAuth.vue?vue&type=template&id=1aaf564d&scoped=true", () => {
    api.rerender('1aaf564d', render)
  })

}


export default __exports__